// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";

$(function () {
  const showToast = () => {
    const elements = [].slice.call(document.querySelectorAll(".toast"));
    const toasts = elements.map(function (toastEl) {
      return new bootstrap.Toast(toastEl);
    });
    toasts.forEach((toast, index) => {
      toast.show();

      // Focus on first toast if close button has autofocus attribute
      if (index === 0) {
        elements[index].querySelector("[autofocus]")?.focus();
      }
    });
  };
  showToast();

  Drupal.behaviors.bootstrap_barrio_toast = {
    attach: function (context, settings) {
      showToast();
    },
  };

  $("body").popover({
    html: true,
    placement: "auto",
    container: "body",
    trigger: "hover focus",
    selector: '[data-bs-toggle="popover"]',
  });

  $.fn.modalScrollToTop = function () {
    setTimeout(function () {
      document.getElementById("drupal-modal").scrollTop = 0;
    }, 1);
  };

  $("input.form-control, select.form-control, textarea.form-control").each(
    () => {
      if ($(this).val() && $(this).closest(".js-form-item")) {
        $(this).closest(".js-form-item").addClass("is-focused");
        $(this).addClass("active");
      }
    }
  );

  // Focus on first element with an error for accessibility
  $(":input.error:visible:enabled:first")?.focus();

  $(document).click(function (event) {
    let target = $(event.target);
    let _mobileMenuOpen = $(".navbar-collapse").is(".show");
    if (_mobileMenuOpen === true && !target.is(".navbar-toggler")) {
      $("button.navbar-toggler").click();
    }

    let floating_menu = $("#menu-open");
    if (
      floating_menu.is(":checked") &&
      !target.is(".fas.fa-plus, .menu-open")
    ) {
      floating_menu.prop("checked", false);
    }
  });

  $(".ts-collapse-pane").on("click keydown", (e) => {
    let target = e.target
    // Filtrer les événements pour le clavier
    if (e.type === "keydown") {
      // Activer uniquement pour "Enter" ou "Space"
      if (e.key !== "Enter" && e.key !== " ") {
        // Ignorer les autres touches
        return;
      }
      // Empêcher le comportement par défaut de "Space" (scroll de la page)
      e.preventDefault();

      target = e.target.parentElement;
    }

    $(target).toggleClass("collapsed");
    $(target).next().animate({ opacity: "toggle", height: "toggle" }, 250);
  });

  /**
   * Show popover if input next is description
   */
  $("input.form-control").hover(
    function () {
      let small = $(this).next("small");
      if (small.length > 0) {
        $(this).popover("show");
      }
    },
    function () {
      let small = $(this).next("small");
      if (small.length > 0) {
        $(this).popover("hide");
      }
    }
  );

  /**
   * Preload page
   */
  $("form.user-login-form, form.gieps-user-login-form").on(
    "submit",
    function (e) {
      $("#loader-wrapper").addClass("loaded");
    }
  );

  $(document).on("click", ".logout-link", function (e) {
    $("#loader-wrapper").addClass("loaded");
  });

  $(document)
    .on(
      "focus change",
      "input.form-control, select.form-control, textarea.form-control",
      function () {
        // Add class on focus to label + input
        if ($(this).closest(".js-form-item")) {
          $(this).closest(".js-form-item").addClass("is-focused");
          $(this).addClass("active");
        }
      }
    )
    .on(
      "blur",
      "input.form-control, select.form-control, textarea.form-control",
      function () {
        // Remove class on focus to label + input
        if ($(this).closest(".js-form-item")) {
          $(this).closest(".js-form-item").removeClass("is-focused");
        }
        if (!$(this).val()) {
          $(this).removeClass("active");
        }
      }
    )
    .on("keypress", 'form[novalidate="novalidate"]', function (event) {
      // Textarea press Enter remove default action
      if (event.keyCode === "13" && event.target.type !== "textarea") {
        event.preventDefault();
      }
    })
    .on("click keydown", ".seepass", function (e) {
      // Pour le clavier, on ne réagit qu'à Espace ou Entrée
      if (e.type === "keydown" && e.key !== " " && e.key !== "Enter") {
        return;
      }

      // Empêcher le comportement par défaut pour la touche espace
      if (e.key === " ") {
        e.preventDefault();
      }

      const button = e.currentTarget;
      const icon = button.querySelector('i');
      const input = button.closest('.form-type-password').querySelector('input');

      // Toggle l'icône
      const isVisible = icon.classList.contains('fa-eye-slash');
      icon.classList.toggle('fa-eye', isVisible);
      icon.classList.toggle('fa-eye-slash', !isVisible);

      // Toggle le type du champ
      input.type = !isVisible ? 'password' : 'text';
    })
    .on("input propertychange", ".has-clear input.phone", function () {
      const $this = $(this);
      const empty = Boolean($this.val());
      $(this)
        .closest(".has-clear")
        .find("input.delete")
        .val(!empty ? "1" : "0");
    })
    .trigger("propertychange")
    .on(
      "click touch",
      '.ui-widget-overlay, *[data-dismiss="modal"]',
      function () {
        $("#drupal-modal").dialog("close");
      }
    )
    .on("click touch", "#faq .accordion", function () {
      const item = $(this).closest(".q-item");
      item
        .closest(".asked")
        .find(".q-item")
        .not(item)
        .removeClass("active")
        .find(".q-description")
        .slideUp("100");
      item.toggleClass(".active").find(".q-description").slideToggle("100");
    })
    .on("hidden.bs.toast", () => {
      const removeElements = (elms) => elms.forEach((el) => el.remove());
      removeElements(document.querySelectorAll(".toast-wrapper"));
    })
    .on("click touch", "#dm-info", (e) => {
      $("#dm-infos-second").animate(
        { opacity: "toggle", height: "toggle" },
        250
      );
      $("#dm-info").toggleClass("open");
    })
    .on("click touch", "#secret .button-secret", (e) => {
      $(e.target).toggleClass("health");
    })
    .on("change", "#toggle", (e) => {
      $("#toggle").attr("aria-expanded", e.target.checked);
    })
    .on("focus", "body", (e) => {
      if (!e.target.closest("#user-account") && $("#toggle").prop("checked")) {
        $("#toggle").prop("checked", false);
      }

      if (
        !e.target.closest(".block-one-click-block") &&
        $("#menu-open").prop("checked")
      ) {
        $("#menu-open").prop("checked", false);
      }

      if (
        !e.target.closest("#accordion") &&
        $("#accordionHelp").attr("aria-expanded") === "true"
      ) {
        $("#accordionHelp").click();
      }
    });

  /**
   * ADD LOADER SPINNER FOR AJAX REQUEST
   */
  const ajaxBeforeSubmitOriginal = Drupal.Ajax.prototype.beforeSubmit;
  Drupal.Ajax.prototype.beforeSubmit = function (
    form_values,
    element,
    options
  ) {
    const regEx =
      /^(?=.*_wrapper_format=drupal_modal\b)(?=.*_wrapper_format=drupal_ajax\b).*$/g;
    let url = options.url;

    if (regEx.test(url)) {
      url = url.replace(/_wrapper_format=drupal_modal/g, "");
      url = url.replace(/&&/g, "&");
      options.url = url;
    }

    if (
      options.extraData !== undefined &&
      "_triggering_element_name" in options.extraData
    ) {
      const str = options.extraData._triggering_element_name;
      const beginWith = str.startsWith("field_");
      const endWith = str.endsWith("_upload_button");

      if (element.hasClass("loading-demarche") || (beginWith && endWith)) {
        element.parents("#drupal-modal").addClass("loading");
      }

      if (element.hasClass("loading-comment")) {
        element.parents("#response-wrapper").addClass("loading");
      }
    }

    // call original function since it can be already overridden
    ajaxBeforeSubmitOriginal.call(this, form_values, element, options);
  };

  const ajaxSuccessOriginal = Drupal.Ajax.prototype.success;
  Drupal.Ajax.prototype.success = function (form_values, element, options) {
    $("#drupal-modal").removeClass("loading");
    $("#response-wrapper").removeClass("loading");

    // Check if the specific div with class exists.
    const fileInputContainer = document.querySelector(
      ".js-form-item.js-form-type-managed-file.form-type-managed-file.form-no-label.is-focused"
    );

    // Check if the condition in form_values should not contain "update_build_id".
    const formValuesContainUpdateBuildId = () => {
      for (const formValue of form_values) {
        if (formValue.command === "update_build_id") {
          // "update_build_id" found, so the condition is true.
          return true;
        }
      }

      // The above code is a JavaScript function that returns the boolean value false.
      return false;
    };

    if (fileInputContainer && !formValuesContainUpdateBuildId()) {
      // Remove the 'is-focused' class.
      fileInputContainer.classList.remove("is-focused");
    }

    ajaxSuccessOriginal.call(this, form_values, element, options);
    const floatContainers = document.querySelectorAll("input.form-control");
    floatContainers.forEach((element) => {
      if (element.value) {
        element.classList.add("active");
      }
    });
  };

  const ajaxBeforeSendOriginal = Drupal.Ajax.prototype.beforeSend;
  Drupal.Ajax.prototype.beforeSend = function (xmlhttprequest, options) {
    if (this.element && !this.element.classList.contains("menu-item")) {
      ajaxBeforeSendOriginal.call(this, xmlhttprequest, options);
    }
  };

  /**
   * END LOADER SPINNER
   */

  /**
   * Preventing page from redirecting
   */
  $(document).on("dragover drop", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  /**
   * DRAG & DROP
   */
  $(document)
    .on(
      "drag dragstart dragend dragover dragenter dragleave drop",
      ".form-type-managed-file .box-file",
      function (e) {
        e.stopPropagation();
        e.preventDefault();
      }
    )
    .on(
      "dragover dragenter",
      ".form-type-managed-file .box-file",
      function (e) {
        $(this).addClass("is-dragover");
      }
    )
    .on(
      "dragleave dragend drop",
      ".form-type-managed-file .box-file",
      function () {
        $(this).removeClass("is-dragover");
      }
    )
    .on("drop", ".form-type-managed-file .box-file", function (e) {
      $(this)
        .find("input[type='file']")
        .prop("files", e.originalEvent.dataTransfer.files);
      $(this).parent().find("button.form-submit").mousedown();
    });

  $(window).on("dialogclose", function (e, dialog, $element) {
    $("body").removeClass("modal-open");
  });

  $(window).on("dialogopen", function (e, dialog, $element) {
    $("body").addClass("modal-open");

    let _mobileMenuOpen = $(".navbar-collapse").is(".show");
    if (_mobileMenuOpen === true) {
      $("button.navbar-toggler").click();
    }

    let floating_menu = $("#menu-open");
    if (floating_menu.is(":checked")) {
      floating_menu.prop("checked", false);
    }
  });

  Drupal.bienvenueStep = function (step, id) {
    let $bien = $("#bienvenue-modal");
    let $step = $("#step-bienvenue");
    let $square = $("#step-bienvenue .square");
    let $hr = $("#step-bienvenue .hr-step");

    if (step === "close") {
      $bien.fadeOut("fast");
      let $visite = document.getElementById("dontsee").checked;

      if (id === 2 || $visite) {
        let data = {
          visite: true,
        };

        $.ajax({
          url: Drupal.url("LRdDpfFtTRdhLRCoQdqMrzftGYNsXY"),
          type: "POST",
          data: JSON.stringify(data),
          contentType: "application/json; charset=utf-8",
          dataType: "json",
        });
      }
    } else if (step === "active") {
      $bien
        .find(".dialog > .first")
        .removeClass("active")
        .hide("fast", function () {
          $bien.find(".dialog > .second").addClass("active").show();
        });
    } else if (step === "next") {
      $step
        .find(".item.active")
        .removeClass("active")
        .next()
        .addClass("active");
      $square
        .find(".s-item.active")
        .removeClass("active")
        .next()
        .addClass("active");
      $hr
        .find(".e-item.active")
        .removeClass("active")
        .next()
        .addClass("active");

      id = $step.find(".item.active").attr("data-id");
      $step
        .find(".step-container")
        .css("transform", "translateX(-" + id + "00%");

      if (id === $step.find(".item.end").attr("data-id")) {
        $step.find(".bottom .next").hide();
        $step.find(".bottom .next-close").show();
      }
    } else if (step === "item") {
      $step.find(".item.active").removeClass("active");
      $square.find(".s-item.active").removeClass("active");
      $hr.find(".e-item.active").removeClass("active");
      $step.find('.item[data-id="' + id + '"]').addClass("active");
      $step
        .find(".step-container")
        .css("transform", "translateX(-" + id + "00%");
      $square.find('.s-item[data-id="' + id + '"]').addClass("active");
      $hr.find('.e-item[data-id="' + id + '"]').addClass("active");

      if (id === $step.find(".item.end").attr("data-id")) {
        $step.find(".bottom .next").hide();
        $step.find(".bottom .next-close").show();
      } else {
        $step.find(".bottom .next").show();
        $step.find(".bottom .next-close").hide();
      }
    }

    if (
      $(document).width() > 995 &&
      (step === "item" || step === "next" || step === "active")
    ) {
      let position = $("#navbar-top .region-top-header nav.menu--main ul.nav")
        .children()
        .eq(id)
        .position();
      let widthItem =
        $("#navbar-top .region-top-header nav.menu--main ul.nav")
          .children()
          .eq(id)
          .width() / 2;

      $("#bienvenue-modal > .dialog").css({
        position: "fixed",
        top: position.top + "px",
        left: position.left + widthItem + "px",
        transform: "translate(-50%, 30px)",
      });
    }
  };

  let accordion = document.getElementById("accordionHelp");
  if (typeof accordion != "undefined" && accordion != null) {
    function openAccordionHelp(elem) {
      const accordionStyle = document.getElementById("accordion");
      accordionStyle.classList.toggle("invisible");
      elem.classList.toggle("active");

      // Toggle aria-expanded
      let isExpanded = elem.getAttribute("aria-expanded") === "true";
      elem.setAttribute("aria-expanded", !isExpanded);

      // Disable button from tabindex when accordion help is open
      document.querySelector(".button-visite > a").toggleAttribute("disabled");
    }

    accordion.addEventListener("click", (e) => {
      openAccordionHelp(e.target);
    });

    accordion.addEventListener("keydown", (e) => {
      if (e.key === " " || e.code === "Space") {
        e.preventDefault();
        openAccordionHelp(e.target);
      }

      if (e.code === "Tab" && !e.shiftKey && e.target.classList.contains('active')) {
        e.preventDefault();
        document.querySelector("#accordion button").focus();
      }
    });
  }

  $(document).on("keydown", ".file-label-acc", function (e) {
    if (e.key === " " || e.code === "Space") {
      const elem = e.target;
      elem.parentElement.querySelector('input[type="file"]').click();
    }
  });

  window.addEventListener('dialog:aftercreate', function (e) {
    const closeDialogButton = $(e.target).parent().find('.ui-dialog-titlebar-close');

    closeDialogButton.attr('aria-label', 'Fermer');

    const titleDialogSpan = $(e.target).parent().find('.ui-dialog-title');

    if (titleDialogSpan.length) {
      const titleText = titleDialogSpan.text();
      const newH2 = $('<h2>').text(titleText);

      $.each(titleDialogSpan[0].attributes, function () {
          newH2.attr(this.name, this.value);
      });

      titleDialogSpan.replaceWith(newH2);
    }
  });

});
